module.exports = __webpack_public_path__ + "media/src/images/onboarding__img-d0aaadcd5b1ee4967c65a2d5cec3c858.svg";